import Diglett from './Diglett';

export default Diglett;



/** WEBPACK FOOTER **
 ** ./source/050-diglett/index.js
 **/